import { PayloadAction } from '@reduxjs/toolkit'
import { IProject } from 'types/project'
import { IProjectState, IProjectThumbnailPath } from 'store/types/project'
import { IProjectMetaDataResponse } from 'types/projectMeta'
import { reducerCreatorProducer } from 'store/common'

const reducers = reducerCreatorProducer<IProjectState>()({
  setIsLoading: (state, action: PayloadAction<boolean>) => {
    state.isLoading = action.payload
  },
  setProject: (state, action: PayloadAction<IProject>) => {
    state.data = action.payload
    state.isNewProject = false
  },
  setCreatedProject: (state, action: PayloadAction<IProject>) => {
    state.data = action.payload
    state.isNewProject = false
  },
  setIsRendering: (state, action: PayloadAction<boolean>) => {
    state.isRendering = action.payload
  },
  setProjectDataName: (state, action: PayloadAction<string>) => {
    state.data.name = action.payload
  },
  setMetaData: (state, action: PayloadAction<IProjectMetaDataResponse>) => {
    state.metaData = action.payload
  },
  setIsNewProject: (state, action: PayloadAction<boolean>) => {
    state.isNewProject = action.payload
  },
  setProjectThumbnailPath: (
    state,
    action: PayloadAction<IProjectThumbnailPath | null>
  ) => {
    state.projectThumbnailPath = action.payload
  }
})

export default reducers
